<template>
  <div :class="['page-body',className]" :style="style">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'layoutBody',
  props: {
    paddingTop: Number,
    hasToolbar: {
      type: Boolean,
      default: true,
    },
    mode: {
      type: String,
      default: '', // 可选值为 horizontal（水平） 和 vertical（垂直）
    },
  },
  computed: {
    style() {
      if(this.paddingTop == null) {
        return {}
      }else{
        return {
          'paddig-top' : this.paddingTop + 'px'
        }
      }
    },
    className() {
      let className = this.mode || ''
      if(!this.hasToolbar) {
        className += ' no-toolbar'
      }
      return className
    }
  }
}
</script>

<style lang="scss" scoped>
.page-body{
  &.horizontal{
    flex-direction: row;
  }
}
</style>


